package ui.component.tabs

import emotion.react.css
import helpers.isPhone
import react.FC
import react.Props
import react.dom.html.ReactHTML
import react.useContext
import ru.malygin.dateTime.WhatDay
import ru.malygin.dto.MainScheduleItemDto
import ru.malygin.myConst.SelectedCategory
import ru.malygin.myConst.TimeDetectorItem
import ui.component.MainScreenComponentsOpen
import ui.new_ui.components.card_handler.CardHandler
import ui.styles.Styles
import ui.themePlusContext.ToastContext
import ui.themePlusContext.ToastData
import utils.logger.log
import web.cssom.*

external interface TabsProps: Props {
    var category: SelectedCategory
    var selectedGroupForTutor: String
}

class Tabs(
    days:List<TimeDetectorItem> = WhatDay().returnWeekDay(),
    private val groupedReceivedList: List<List<MainScheduleItemDto>?>?,
    activeTab: Int,
    val onActiveTabChange: (Int) -> Unit,
)  {

    private var currentTab = activeTab
    private var currentWeekDay = days[currentTab]
    private var targetTab = days.indexOfFirst {
        it.targetDay == 1
    }

    val tabsHead = FC {//{props ->
        val phone = isPhone()
        val toast = useContext(ToastContext)

        ReactHTML.section{
            className = Styles.Elements.tabsHeader

            ReactHTML.menu{

                ReactHTML.ul{

                    days.forEachIndexed {index, dayTime->
                        val idCreate = "$index|${dayTime.nameOfDay}|${dayTime.onlyDateOfDay}"


                        ReactHTML.li{
                            id = idCreate
                            className = setDecoration(
                                currentClassName = Styles.Elements.tabsHeaderListItem,
                                days = days,
                                activeTab = currentTab,
                                index = index,
                                targetTab = targetTab
                            )

                            ReactHTML.button{
                                val currentDateDebug = returnNotNullableData(dayTime,returnFullDate = true)
                                val currentBooleanDate = tryToCheckDate(dayTime.onlyDateOfDay, currentDateDebug)

                                className = Styles.Buttons.button

                                this.onClick = {
                                    onChangeTab(index)

                                    if(currentBooleanDate){
                                        if(phone){
                                            toast.open(
                                                ToastData(
                                                    message = "Показаны данные на другую дату [${currentDateDebug}] ( нет данных на сервере )",
                                                    timeout = 4200
                                                )
                                            )
                                        }
                                    }
                                }

                                ReactHTML.div{
                                    css {
                                        display = Display.flex
                                        flexDirection = FlexDirection.column
                                        alignItems = AlignItems.center
                                    }

                                    ReactHTML.div{

//                                        log.d("[DEBUG DATE TABS HEADER]:[${dayTime.nameOfDay}|${dayTime.onlyDateOfDay}] ~ ${currentDateDebug}")

                                        css(this.className){
                                            gap = 5.px
                                            display = Display.flex
                                        }

                                        if(currentBooleanDate){
                                            title = "Показаны данные на другую дату [${currentDateDebug}] ( нет данных на сервере )"

                                            ReactHTML.s{
                                                css {
                                                    opacity = number(0.5)
                                                }
                                                +dayTime.dayByNumber
                                            }
                                        }

                                        ReactHTML.span{

                                            +returnNotNullableData(dayTime)
                                        }
                                    }

                                    ReactHTML.hr{
                                        className = Styles.Elements.divider

                                    }
                                    ReactHTML.span{
                                        +dayTime.nameOfDay.shortName
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }

    val tabsBody = FC<TabsProps>{props ->
        groupedReceivedList?.let { keku->

            CardHandler{
                /**
                 * Перекидываем данные на конкретный день
                 */
                MainScreenComponentsOpen(
                    category = props.category,
                    selectedGroupForTutor = props.selectedGroupForTutor
                ).tabPanelCard{
                    this.itemsDto = keku.getOrElse(
                        keku.indexOfFirst {
                            it?.first()?.dayOfWeek == currentWeekDay.nameOfDay
                        }
                    ){null}
                    this.indexDays = currentTab
                    this.timeDetectorItem = currentWeekDay
                }
            }

        }?: run{
            /**
             * Пока нет данных, показываем заглушку
             */
            MainScreenComponentsOpen(props.category).onLoadingSkeleton()
        }
    }

    private fun onChangeTab(
        newTabIndex: Int
    ){
        currentTab = newTabIndex
        onActiveTabChange(newTabIndex)
    }

    private fun setDecoration(
        currentClassName: ClassName,
        days: List<TimeDetectorItem>,
        activeTab: Int,
        index: Int,
        targetTab: Int
    ): ClassName{
        var x = currentClassName
        x = when(index){
            0 -> {
                ClassName("$x ${Styles.Buttons.tokenButtonModifiedForElementF}")
            }

            days.size - 1 -> {
                ClassName("$x ${Styles.Buttons.tokenButtonModifiedForElementL}")
            }

            else -> {
                ClassName("$x ${Styles.Buttons.tokenButtonModifiedForElementM}")
            }
        }

        when(index){
            activeTab -> {
                x = ClassName("$x ${Styles.Buttons.buttonTarget}")
            }
            else ->Unit
        }

        when(index){
            targetTab -> {
                x = ClassName("$x ${Styles.Elements.tabTarget}")
            }
            else->Unit
        }
        return x
    }

    /**
     * Возвращает строку с датой
     *
     * похоже на 14
     */
    private fun returnNotNullableData(
        dayTime: TimeDetectorItem,
        returnFullDate: Boolean = false
    ): String{
        val nullableDate = returnNullableData(
            dayTime = dayTime,
            groupedReceivedList = groupedReceivedList,
            returnFullDate = returnFullDate
        )

        return nullableDate ?: if (returnFullDate) dayTime.onlyDateOfDay else dayTime.dayByNumber
    }

    /**
     * Возвращает true если данные из разных недель
     */
    private fun returnIsDataFromDifferentWeek(
        dayTime: TimeDetectorItem
    ): Boolean{
        val nullableDate = returnNullableData(dayTime, groupedReceivedList)
        val notNullableData = returnNotNullableData(dayTime)

        return nullableDate?.let { it != notNullableData } ?: false
    }

    private fun tryToCheckDate(
        dayTimeDate: String,
        otherDate: String
    ): Boolean{
        return dayTimeDate != otherDate
    }

    companion object{

        /**
         * Возвращает строку с датой
         *
         * похоже на 14 или NULL
         */
        fun returnNullableData(
            dayTime: TimeDetectorItem,
            groupedReceivedList: List<List<MainScheduleItemDto>?>?,
            returnFullDate: Boolean = false
        ): String?{
            val intDate = groupedReceivedList?.indexOfFirst {
                it?.first()?.dayOfWeek == dayTime.nameOfDay
            }?:-1
            val nullableDate = if (returnFullDate){
                groupedReceivedList?.getOrNull(intDate)?.first()?.dataAdded
            }else {
                groupedReceivedList?.getOrNull(intDate)?.first()?.dataAdded?.split(".")?.get(0)
            }
            return nullableDate
        }
    }
}